import React,{FunctionComponent} from 'react'
import {Table as Tables} from 'antd'
import {TableProps} from "antd/lib/table";
import StylesType from "@/types/StylesType";
import classnames from 'classnames'
import './style/index.less'


const Table: FunctionComponent<TableProps<any> & StylesType> = props => {
    let {prefixCls='gc_', className=''} = props
    return <Tables {...props} className={classnames(prefixCls+className, 'table')}></Tables>
}

export default Table
